module.exports = __webpack_public_path__ + "img/manafwa9.3ab7f8f8.jpg";